import styled from 'styled-components';


export const Label = styled.div`
  box-shadow: inset 0px 0px 10px 0px rgba(185, 185, 186, 1);
  border-radius: 3px;
  font-size: 12px;
  padding: 2px;
  background-color: white;
  align-self: center;
  text-align: center;
  max-width: 150px;
   color: ${({ theme }) => theme.colors.darkPink};
}
`;

export const StyledHeader = styled.div`
display: grid;
gap: 10px;
grid-template-columns: auto 1fr;
margin-bottom: 5px;
`;

export const JiraIssueStyled = styled.ul`
  margin: 0;
  padding: 0;
  display: grid;
  grid-column: span 2;
  grid-template-columns: repeat(2, minmax(0, 1fr)); 
  grid-gap: 10px;
  align-self: start;
  max-height: 100%;
  overflow-y: auto; 
  overflow-x: hidden;

  &.showalltasks {
    max-height: 80%;
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    grid-template-columns: 1fr; 
    font-size: 12px;
  }
`;


export const WorklogItem = styled.div`
  align-self: start;
  display: grid;
  grid-template-rows: repeat(4, minmax(0, auto)) 1fr;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  color: ${({ theme }) => theme.colors.shadyLady};
  font-size: 14px;
  height: 100%;

  h3 {
    margin: 0;
    max-width: 100%;
  }

  p {
    margin: 0;
    max-width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    overflow: hidden;
    align-self: start;
  }

  .nieserwisowe {
    font-size: 12px;
    color: red;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 5px;
    border-radius: 4px;
    text-align: center;
    max-width: 100%;
    word-wrap: break-word;
  }
`;


export const WorklogLink = styled.a`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.pink};
  text-decoration: none;
  max-width: 100%;
  margin-bottom:10px;

  &:hover {
    text-decoration: underline;
  }
`;

export const ToggleButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.pink};
  cursor: pointer;
  margin: 5px 0;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
  transition: color 0.3s ease-in-out;

  &:hover {
    color: ${({ theme }) => theme.colors.darkPink};
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.tabletMax}) {
    font-size: 12px;
  }
`;

export const LogsContainer = styled.div`
  max-height: ${(props) => (props.$expanded ? '200px' : '0')}; 
  overflow-y: auto; 
  overflow-x: hidden; 
  transition: max-height 0.3s ease-in-out;
  display: grid;
  font-size: 13px;
  margin-left: 30px;

    p {
    margin: 3px;
  }
`;


export const LogEntry = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 5px;
  box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.05);
`;

export const TimeRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center; 
  margin: 5px 0;
  width: 100%;
`;

export const UnSettledTime  = styled.p`
  color: ${({ theme }) => theme.colors.green};
  border-top: 1px solid ${({ theme }) => theme.colors.green};
  padding-top:10px;
`; 
